enum SocialSubmissionTypes {
  Carousel = 'carousel',
  Pin = 'pin',
  StandardVideo = 'standard_video',
  Reel = 'reel',
  Shorts = 'shorts',
  Standard = 'standard',
  Story = 'story',
  Text = 'text',
  TikTok = 'tiktok',
  Snap = 'snap',
}

export { SocialSubmissionTypes }
